import React, { memo, PropsWithChildren } from 'react';

const LinkBadge = React.forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<{
    active?: boolean;
    className?: string;
    href: string;
    variant?: 'default' | 'secondary';
  }>
>(({ active, children, className = '', variant, ...props }, ref) => (
  <a
    {...{
      className: [
        'text-sm cursor-pointer transition-all duration-200 focus:outline-none outline-none rounded-lg border',
        active
          ? 'border !border-green bg-green-100 pointer-events-none font-medium'
          : '',
        variant === 'secondary'
          ? 'px-3 py-2 md:px-6 md:py-3 border-indigo-200 hover:bg-lilac-50 hover:border-lilac-300'
          : 'px-2 py-1 border-transparent hover:border-green-400 hover:bg-green-100',
        className,
      ].join(' '),
      ref,
    }}
    {...props}
  >
    {children}
  </a>
));

export default memo(LinkBadge);
